export const getWhatsAppUrl = (message = "Hello ASCSI, I would like to make a wholesale or export enquiry.") =>
  `https://wa.me/919390133121?text=${encodeURIComponent(message)}`;